import { VideoService } from './../services/video.service';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { CreateComponent } from './pages/create/create.component';
import { ProjectModuleWithoutRouting } from '@layouts/default/layouts/logged/pages/project/project.module-without-routing';

const routes: Routes = [
  { path: 'create', component: CreateComponent },
  {
    path: 'edit/:id',
    component: CreateComponent,
  },
];

@NgModule({
  imports: [ProjectModuleWithoutRouting, RouterModule.forChild(routes), SharedModule],
  providers: [VideoService],
})
export class ProjectModule {}
